import {Inject, Injectable} from "@angular/core";
import {SignalrService} from "@core/services/signalr-service";
import {interval, Observable, Subject} from 'rxjs';
import {select, Store} from "@ngrx/store";
import {getUserInfo} from "@shared/store/selectors/security.selector";
import {filter, flatMap, map, mergeMap, takeUntil, timeInterval} from 'rxjs/operators';
import {SecurityState} from "@shared/store/reducers/security.reducer";
import {EventStatus} from "@shared/models/notification-message.model";
import {getQueryResponse} from "@shared/store/selectors/query.selector";
import {IQueryState} from "@shared/store/reducers/query.reducer";
import {getNotification} from "@shared/store/toast/toast-selectors";
import {IToastState} from "@shared/store/toast/toast-reducer";
import {DashboardService} from '@core/services/dashboard.service';


@Injectable()
export class VisualizerNotificationService{
  private notificationSubject: any;
  private demoHistory$: any;
  private notifications$: Observable<any>;
  public pullingSubscribe$: Subject<void>;
  private timerCount: number;
  private pullingId: string;
  private reportType: string;
  constructor(private signalrService : SignalrService,
              private securityStore : Store<SecurityState>,
              private queryState : Store<IQueryState>,
              private toastStore : Store<IToastState>,
              private dashboardService : DashboardService) {
    this.notificationSubject = {};
  }

  public subscribeToEvent(command) : Subject<any>{
    let subject$ = this.notificationSubject[command.id];
    if(!subject$){
      subject$ = new Subject<void>();
      this.notificationSubject[command.id] = subject$;
    }
    this.demoHistory$ = this.queryState.pipe(select(getQueryResponse, 'MyDemo'));

    this.demoHistory$.subscribe(state => {
      if(state){
        console.log("Subscribing to demo from visualizerNotificationService");
        this.listenToStoreForNotification(command);
        // this.signalrService.openChannel(state.id).subscribe(response => {
        //
        // });
      }
      else{
        this.securityStore.pipe(select(getUserInfo), filter(val => val!=null && val!=undefined)).subscribe(userInfo => {
          console.log("SR-Signalr subscribing to user channel from analytics");
          this.listenToStoreForNotification(command);
        });
      }
    });

    return subject$.asObservable();
  }
  listenToStoreForNotification(command){
    this.startPullingV2(command);
    this.notifications$ = this.toastStore.pipe(select(getNotification, command.id));
    this.notifications$.subscribe(response => {
      if(response){
        console.log("SR-Signalr Received in VisualizerNotificationService : ", response);
        if(this.notificationSubject[response.eventId]){
          if(response.status == EventStatus.Failed){
            this.notificationSubject[response.eventId].error(response.payload);
            delete this.notificationSubject[response.eventId];
          }
          else{
            this.notificationSubject[response.eventId].next(response);
            this.notificationSubject[response.eventId].complete();
            delete this.notificationSubject[response.eventId];
          }
          this.destroyPulling();
        }
      }
    });
  }
  startPullingV2(command: any): boolean {
    if(command.id) {
      this.pullingId = command.id;
    }
    if(command.reportType) {
      this.reportType = command.reportType;
    }
    if(!command.id && !this.pullingId){
      return false;
    }
    this.pullingSubscribe$ = new Subject<void>();
    this.timerCount = 0;
    interval(30*1000)
      .pipe(timeInterval())
      .pipe( takeUntil(this.pullingSubscribe$) )
      .pipe(mergeMap(() => this.dashboardService.getAnalyticsResetStatus(this.pullingId, command.reportType)))
      .subscribe((response:any) =>{
        if(response){
          if(this.notificationSubject[response.eventId]){
            if(response.status == EventStatus.Failed){
              this.notificationSubject[response.eventId].error(response.payload);
              delete this.notificationSubject[response.eventId];
            }
            else{
              this.notificationSubject[response.eventId].next(response);
              this.notificationSubject[response.eventId].complete();
              delete this.notificationSubject[response.eventId];
            }
          }
          this.destroyPulling();
        }
        else{
          this.timerCount++;
          console.log("Pulling in ResetVisualizerData : ", this.timerCount)
        }
      },error => {
      this.destroyPulling();
      console.log("Error in pulling ResetVisualizerData");
    });
    return true;
  }
  startPulling(commandId? : string) : boolean{
    if(commandId) {
      this.pullingId = commandId;
    }
    if(!commandId && !this.pullingId){
      return false;
    }
    this.pullingSubscribe$ = new Subject<void>();
    this.timerCount = 0;
    interval(20 * 1000)
      .pipe(timeInterval())
      .pipe( takeUntil(this.pullingSubscribe$) )
      .pipe(mergeMap(() => this.dashboardService.getAnalyticReportConfig(this.pullingId)))
      .subscribe((response : any) => {
        if(response){
          if(this.notificationSubject[response.eventId]){
            if(response.status == EventStatus.Failed){
              this.notificationSubject[response.eventId].error(response.payload);
              delete this.notificationSubject[response.eventId];
            }
            else{
              this.notificationSubject[response.eventId].next(response);
              this.notificationSubject[response.eventId].complete();
              delete this.notificationSubject[response.eventId];
            }
          }
          this.destroyPulling();
        }
        else{
          this.timerCount++;
          console.log("Pulling in AnalyticReportConfig : ", this.timerCount)
        }
      }, error => {
        this.destroyPulling();
        console.log("Error in pulling AnalyticReportConfig");
      });
    return true;
  }
  destroyPulling(){
    if(this.pullingSubscribe$){
      this.pullingSubscribe$.next();
      this.pullingSubscribe$.complete();
    }
  }
}
